import { useState } from "react";
import { Star } from "@phosphor-icons/react";

/** Star row. Read-only when no onChange. */
export function StarRating({ value = 0, onChange, size = 18, testid = "stars", className = "" }) {
  const [hover, setHover] = useState(0);
  const shown = hover || value || 0;
  return (
    <div className={`inline-flex items-center gap-0.5 ${className}`} data-testid={testid} data-value={value || 0} role={onChange ? "radiogroup" : undefined}>
      {[1, 2, 3, 4, 5].map((n) => (
        <button key={n} type="button" disabled={!onChange} onClick={() => onChange && onChange(n)} onMouseEnter={() => onChange && setHover(n)} onMouseLeave={() => onChange && setHover(0)}
          className={`${onChange ? "cursor-pointer hover:scale-110 transition-transform" : "cursor-default"} disabled:cursor-default`} aria-label={`${n} star${n !== 1 ? "s" : ""}`} data-testid={`${testid}-${n}`}>
          <Star size={size} weight={n <= shown ? "fill" : "regular"} className={n <= shown ? "text-amber-400" : "text-muted-foreground/40"} />
        </button>
      ))}
    </div>
  );
}

export const RATING_WORDS = { 1: "Poor", 2: "Below expectations", 3: "OK", 4: "Good", 5: "Excellent" };
